var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length === 0) return;
		$(window).load(function () {
			site.maxHeight.setHeight(selector);
		});
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},
};


site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]', '#page').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
	advertSvg: function () {
		$('img[src*=".svg"]', '.strevda').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
	footerSvg: function () {
		$('img[src*=".svg"]', 'footer .logo').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};

site.banner = {
	init: function () {
		$('.image.loading').bgLoaded();
	},
};

site.OpenFancyBox = {
	init: function () {
		$('#fancybox__btn').click(function (e) {
			e.preventDefault();
			$.fancybox($('a.fancybox'));
		});
	},
};

site.ferdagjof = {
	init: function () {
		const EL_NAME = '#ferdagjof';
		const elements = document.querySelectorAll(EL_NAME);

		window.onscroll = function () {
			elements.forEach(function (el) {
				if (!el.classList.contains('bounce-in-top') && site.ferdagjof.isInView(el)) {
					el.classList.add('bounce-in-top');
				}
			});
		};
		window.dispatchEvent(new Event('scroll'));
	},
	isInView: function (elem) {
		const IN_VIEW_OFFSET_DESKTOP = 70;
		const IN_VIEW_OFFSET_MOBILE = 0;

		let offset = window.innerWidth >= 992 ? IN_VIEW_OFFSET_DESKTOP : IN_VIEW_OFFSET_MOBILE;
		let bounding = elem.getBoundingClientRect();
		return (bounding.top >= 0 && bounding.left >= 0
			&& bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			&& bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset
		);
	},
	mapListToggle: function () {
		let radioButtons = document.querySelectorAll('.travel__viewType input');
		let body = document.body;
		let travelChildren = document.querySelectorAll('#travel .boxText > div:not(.travel__results)');
		Array.prototype.forEach.call(radioButtons, function (el) {
			el.addEventListener('click', () => {
				body.classList.forEach(className => {
					if (className.startsWith('travelView')) {
						body.classList.remove(className);
					}
				});
				if (el.checked === true) {
					Cookies.set('travelView', 'travelView' + el.value);
					body.classList.add('travelView' + el.value);
				}
				Array.prototype.forEach.call(travelChildren, function (el) {
					el.classList.add('fadeIn');
				});
				if (body.classList.contains('travelViewmap')) {
					moya.map.osmMap.invalidateSize();
				}

				setTimeout(function () {
					let filters = document.querySelector('.travel__results .filter');
					if (filters) {
						$('.results span', '#travel .boxText').text($('.travel__service:visible').length);
					}
					Array.prototype.forEach.call(travelChildren, function (el) {
						el.classList.remove('fadeIn');
					});
				}, 400);
			});
		});
	},
};

site.travelCarousel = {
	init: function () {
		site.owl.init('.travel__categories .services', {
			nav: true,
			items: 6,
			loop: false,
			lazyLoad: true,
			lazyLoadEager: 1,
			dots: false,
			margin: 20,
			navText: ['', ''],
			smartSpeed: 500,
			responsive: {
				0: {
					items: 1,
				},
				520: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1200: {
					items: 4,
				},
				1400: {
					items: 5,
				},
				1600: {
					items: 6,
				},
			},

			onInitialized: function () {
				$('.owl-nav.disabled button').attr('aria-hidden', 'true');
				$('.owl-nav .owl-prev').attr('aria-label', 'Fyrri');
				$('.owl-nav .owl-next').attr('aria-label', 'Næsta');
			},
		});

		var interval = setInterval(function () {
			if ($('.travel__categories .category .services').length == $('.travel__categories .category .services.owl-loaded').length) {
				$('.travel__categories').removeClass('loading');
				$('#carouselLoader').css('display', 'none');
				clearInterval(interval);
			}
		}, 100);
	},
	filter: function () {
		let $filter = $('.filter', '.carouselView .travel__results');

		if (!$filter.length) {
			return false;
		}

		$('button', $filter).on('click', function () {
			setTimeout(function () {
				location.reload();
			}, 600);
		});
	},
};

site.frontpage = {
	init: function () {
		moya.toggle.addFromSelectors('.eventList .dropdown .dropbtn', '.eventList .dropdown .dropdown-content', 'calDrop');
		site.frontpage.mobileMenu();
		site.ferdagjof.init();
		site.svg.advertSvg();
		if (window.innerWidth > 992) {
			$('#map .map__svg').tilt({
				scale: 1.0555,
				perspective: 1500,
				speed: 400,
			});
		}
	},
	mobileMenu: function () {
		var $body = $('body');
		$('.level1 > a', '#mainmenu').on('click', function (e) {
			if ($body.width() < 991) {
				e.preventDefault();
				var $this = $(this);

				if ($('li.level1.down').length > 0) {
					$('.down', '#mobilemenu').removeClass('down');
				}

				var className = $this.closest('li').attr('class').split(' ')[0];
				$('.' + className, '#mobilemenu').addClass('down');
				$('.' + className + ' > a', '#mobilemenu').trigger('click');
				$('#mainmenuToggle').trigger('click');
			}
		});
	},
};

site.calendarFilters = {
	months: undefined,
	boxes: undefined,
	categoryVal: 'all',
	monthVal: 'all',
	townVal: 'all',

	init: function () {
		var $body = $('body');
		if (!$body.is('.calendar')) return;

		var $calendar = $('#calendar');
		var $filters = $calendar.find('.calendar__filters');
		var $categoryFilter = $filters.find('#categoryFilter');
		var $townFilter = $filters.find('#townFilter');
		var $monthFilter = $filters.find('#monthFilter');
		site.calendarFilters.months = $calendar.find('.content .eventsWrapper');
		site.calendarFilters.boxes = $calendar.find('.content .eventsWrapper .event');
		site.calendarFilters.events = $calendar.find('.content .eventsWrapper .events');

		$categoryFilter.on('change', site.calendarFilters.handleCategoryChange);
		$townFilter.on('change', site.calendarFilters.handleTownChange);
		$monthFilter.on('change', site.calendarFilters.handleMonthChange);

		var $hash = location.hash.substr(1);
		if ($hash.length > 0) {
			if ($hash === 'allir-landshlutar') {
				$hash = 'all';
			}
			site.calendarFilters.townVal = $hash;
			site.calendarFilters.updateVisibility();
			document.getElementById('townFilter').value = $hash;
		}
	},

	handleCategoryChange: function () {
		site.calendarFilters.categoryVal = $(this).val();
		site.calendarFilters.updateVisibility();
	},

	handleTownChange: function () {
		site.calendarFilters.townVal = $(this).val();
		site.calendarFilters.updateVisibility();
	},

	handleMonthChange: function () {
		site.calendarFilters.monthVal = $(this).val();
		site.calendarFilters.updateVisibility();
	},

	updateVisibility: function () {
		var $catVal = site.calendarFilters.categoryVal;
		var $townVal = site.calendarFilters.townVal;
		var $monthVal = site.calendarFilters.monthVal;
		site.calendarFilters.boxes.hide();

		if ($townVal === 'all') {
			location.hash = 'allir-landshlutar';
		}
		else {
			location.hash = site.calendarFilters.townVal;
		}

		site.calendarFilters.boxes.filter(function () {
				if ($catVal === 'all' && $townVal === 'all' && $monthVal === 'all') {
					return true;
				}
				if ($catVal === 'all' && $townVal === 'all') {
					return $(this).is('.' + site.calendarFilters.monthVal);
				}
				else if ($catVal === 'all' && $monthVal === 'all') {
					return $(this).is('.' + site.calendarFilters.townVal);
				}
				else if ($townVal === 'all' && $monthVal === 'all') {
					return $(this).is('.' + site.calendarFilters.categoryVal);
				}
				else if ($catVal === 'all') {
					return $(this).is('.' + site.calendarFilters.townVal) && $(this).is('.' + site.calendarFilters.monthVal);
				}
				else if ($townVal === 'all') {
					return $(this).is('.' + site.calendarFilters.categoryVal) && $(this).is('.' + site.calendarFilters.monthVal);
				}
				else if ($monthVal === 'all') {
					return $(this).is('.' + site.calendarFilters.categoryVal) && $(this).is('.' + site.calendarFilters.townVal);
				}
				else {
					return $(this).is('.' + site.calendarFilters.categoryVal) && $(this).is('.' + site.calendarFilters.townVal) && $(this).is('.' + site.calendarFilters.monthVal);
				}
			},
		).show();
		site.calendarFilters.checkIfMonthIsEmpty();
	},

	checkIfMonthIsEmpty: function () {
		$.each(site.calendarFilters.events, function () {
			var $this = $(this);
			$this.parent().show();
			var $visibleEvents = $('.event:visible', $this).length;
			if ($visibleEvents === 0) {
				$this.parent().hide();
			}
		});
	},
};

site.regions = {
	init: function () {
		let $body = $('body');
		moya.toggle.addFromSelectors('header .travel__regions > button', 'header .travel__regions > .wrap', 'regions',
			function () {
				$('header .travel__regions').addClass('open');
			}, function () {
				$('header .travel__regions').removeClass('open');
			});

		moya.toggle.addFromSelectors('#travel .travel__regions > button', '#travel .travel__regions > .wrap', 'regions2',
			function () {
				$('#travel .travel__regions').addClass('open');
			}, function () {
				$('#travel .travel__regions').removeClass('open');
			});

		$('.travel__regions .close').on('click', function (e) {
			let $regions = $(e.target).closest('.travel__regions');
			$('> button', $regions).trigger('click');
		});
		site.maxHeight.init('.travel__regions > .wrap');

		$('a', '.travel__regions').on('click', function (e) {
			e.preventDefault();
			let $this = $(this);
			let region = $this.attr('data-region');

			let currentRegion = $body.attr('class').match(/region-(\w*)/);

			if (currentRegion) {
				$body.removeClass(currentRegion[0]);
			}

			$('.travel__regions > button .label').text($this.text());
			$('.travel__regions .selected').removeClass('selected');

			$this.addClass('selected');

			if (region && region !== 'all') {
				Cookies.set('region', region);
				$body.addClass('hasRegion').addClass('region-' + region);
			}
			else {
				Cookies.remove('region');
				$body.removeClass('hasRegion'); //.removeClass('region-' + region);

			}
			location.reload();
		});
	},
};

site.travel = {
	allMarkers: [],
	filters: function () {
		let $filter = $('.filter', '.travel__results');

		if (!$filter.length) {
			return false;
		}

		function waitForMap() {
			if (typeof moya.map.markers !== 'undefined') {
				const allMarkers = Object.assign({}, moya.map.markers);
				for (const key in allMarkers) {
					site.travel.allMarkers.push(allMarkers[key]);
				}
				site.travel.bindButtons($filter);
			}
			else {
				setTimeout(waitForMap, 250);
			}
		}

		setTimeout(waitForMap);


		let $hash = location.hash.substr(1);
		let $hasOfferButton = $('button#hasOffer');
		let $hasGiftButton = $('button#hasGift');
		let $hasVakinnButton = $('button#hasVakinn');
		let $hasChargingStationsButton = $('button#hasChargingStations');

		if ($hash.length > 0) {
			if ($hash === 'tilbod' && $hasOfferButton.length > 0) {
				$hasOfferButton.trigger('click');
				location.hash = '';
			}
			if ($hash === 'ferdagjof' && $hasGiftButton.length > 0) {
				$hasGiftButton.trigger('click');
				location.hash = '';
			}
			if ($hash === 'vakinn' && $hasVakinnButton.length > 0) {
				$hasVakinnButton.trigger('click');
				location.hash = '';
			}
			if ($hash === 'hasChargingStations' && $hasChargingStationsButton.length > 0) {
				$hasChargingStationsButton.trigger('click');
				location.hash = '';
			}
		}
		else {
			if (Cookies.get('hasOffer') === 'true' && $hasOfferButton.length > 0) {
				$hasOfferButton.trigger('click');
			}
			if (Cookies.get('hasGift') === 'true' && $hasGiftButton.length > 0) {
				$hasGiftButton.trigger('click');
			}
			if (Cookies.get('hasVakinn') === 'true' && $hasVakinnButton.length > 0) {
				$hasVakinnButton.trigger('click');
			}
			if (Cookies.get('hasChargingStations') === 'true' && $hasChargingStationsButton.length > 0) {
				$hasChargingStationsButton.trigger('click');
			}
		}
	},
	bindButtons: function ($filter) {
		let $items = $('.travel__services');
		let $body = $('body');

		$('button', $filter).on('click', function () {
			let $this = $(this);
			let className = $this.attr('id');

			$items.animate({
				opacity: 0,
			}, 400);

			setTimeout(function () {
				$this.toggleClass('checked');
				if ($this.hasClass('checked')) {
					$body.addClass(className);
					Cookies.set(className, 'true');
				}
				else {
					$body.removeClass(className);
					Cookies.remove(className);
				}

				if ($body.hasClass('hasOffer')
					|| $body.hasClass('hasGift')
					|| $body.hasClass('hasVakinn')
					|| $body.hasClass('hasChargingStations')
					|| $body.hasClass('hasAccessible')) {
					$body.addClass('hasFilter');
				}
				else {
					$body.removeClass('hasFilter');
				}

				$items.animate({
					opacity: 1,
				}, 400);


				let filterButtons = document.querySelectorAll('.travel__results .filter button.checked');
				let newMarkers = [];
				const options = document.querySelector('.travel__gmap').getAttribute('data-map-options');
				const mapOptions = moya.map.getMapOptions(JSON.parse(options));

				for (let i = 0; i < site.travel.allMarkers.length; i++) {
					let marker = site.travel.allMarkers[i];
					marker.position = marker.options.position.lat + ',' + marker.options.position.lng;
					if (filterButtons.length !== 0) {
						let show = false;
						Array.prototype.forEach.call(filterButtons, function (el) {
							const tag = el.getAttribute('id');
							if (marker.options.hasOwnProperty('tags') &&
								marker.options.tags.includes(tag)) {
								show = true;
							}
							else if (marker.options.hasOwnProperty('options') &&
								marker.options.options.hasOwnProperty('tags') &&
								marker.options.options.tags.includes(tag)) {
								show = true;
							}
						});
						if (show) {
							newMarkers.push(marker);
						}
					}
				}
				if (newMarkers.length > 0) {
					site.travel.clearMap();
					moya.map.markers = moya.map.addMarkers(newMarkers, moya.map.osmMap, mapOptions);
					moya.map.fitMarkers();
					site.travel.rebindMarkerPopups();

				}
				else {
					site.travel.clearMap();
					moya.map.markers = moya.map.addMarkers(site.travel.allMarkers, moya.map.osmMap, mapOptions);
					moya.map.fitMarkers();
					site.travel.rebindMarkerPopups();
				}
				$('.results span', '#travel .boxText').text($('.travel__service:visible').length);
			}, 400);
		});

	},
	clearMap: function () {
		moya.map.osmMap.eachLayer(function (layer) {
			if (layer._url !== 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png') {
				moya.map.osmMap.removeLayer(layer);
			}
		});
	},
	rebindMarkerPopups: function () {
		moya.map.markers.forEach(marker => {
			marker.bindPopup(marker.options.options.info);
		});
	},
};

site.menu = {
	init: function () {
		$('.level1', '#mainmenu').each(function () {
			let $this = $(this);
			if ($('li.children', $this).length === 0) {
				$this.addClass('simple');
				$('.megamenu', $this).addClass('simple');
			}
		});
	},
};

site.siteScroll = {
	init: function () {
		// Hide Header on on scroll down
		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var navbarHeight = $('header >.contentWrap').outerHeight();

		$(window).scroll(function (event) {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		function hasScrolled() {
			var st = $(this).scrollTop();

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta)
				return;

			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down
				$('body').removeClass('nav-down').addClass('nav-up');
			}
			else {
				// Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$('body').removeClass('nav-up').addClass('nav-down');
				}
			}

			lastScrollTop = st;
		}
	},
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.regions.init();
	site.travel.filters();
	site.menu.init();
	site.nav.init();
	site.svg.footerSvg();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.hasBanner')) {
		site.banner.init();
	}

	if ($body.is('.calendarOverview')) {
		site.calendarFilters.init();
	}

	if ($body.is('.carouselView')) {
		site.travelCarousel.init();
		site.travelCarousel.filter();
	}

	if ($body.is('.travel')) {
		site.OpenFancyBox.init();
	}

	if ($(window).width() < 992) {
		site.siteScroll.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table:not([data-moya-compontent="site.responsiveTable"])', 'main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function (e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});

	$body.removeClass('preload');

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
